export default __webpack_public_path__ + "static/media/ReportPDF.7b64a85d.svg";